<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="specialCostChartRef"
        class="vxe-table-element"
        cell-class-name="multiple-select"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-config="canEdit ? {} : { trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :edit-rules="tableRule"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <template v-slot:buttons>
          <el-button size="small" type="primary" class="vxe-btn-primary">特殊费用项信息</el-button>
          <el-button
            @click="$refs.specialCostChartRef.commitProxy('insert_actived')"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            v-if="showTableBtn"
            >新增</el-button
          >
          <el-button
            @click="deleteRowHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            v-if="showTableBtn"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'expenseCode'">{{
              getName('expenseCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityTypeCode'">{{
              getName('commodityType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityCategoryCode'">{{
              getName('commodityCategory', row['commodityCategoryName'])
            }}</span>
            <span v-else-if="item.field == 'pricingStandard'">{{
              getName('pricingStandard', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'pricingUnit'">{{
              getName('pricingUnit', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'packagingCategory'">{{
              getName('packageCategoryName', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commodityClassificationCode'">{{
              getName('commodityClassificationCode', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'commoditySpecificationsId'">
              {{ row['commoditySpecifications'] }}
            </span>
            <span v-else-if="item.field == 'packingId'">
              {{ row['packing'] }}
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <!--根据表格的tableColumnList显示在编辑状态下不同的控件-->
          <template v-slot:edit="{ row }">
            <el-input
              v-if="item.editRender.name == 'input'"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
            </el-input>
            <el-select
              v-else-if="item.editRender.name == 'commodityType'"
              filterable
              clearable
              multiple
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => goodsTypeChange(row, val)"
            >
              <el-option
                v-for="(i, index) in goodsTypeList"
                :key="index"
                :label="i?.label"
                :value="i?.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commodityCategory'"
              filterable
              clearable
              multiple
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => commodityCategoryChange(val, row, item.field)"
            >
              <el-option
                v-for="(i, index) in goodsCategoryList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'commoditySpecificationsId'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '04')"
            >
              <el-option
                v-for="(i, index) in commoditySpecificationsList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <!-- <el-input
              v-else-if="item.editRender.name == 'commodityClassification'"
              disabled
              v-model="row[item.field]"
            >
            </el-input> -->
            <el-select
              v-else-if="item.editRender.name == 'commodityClassification'"
              filterable
              clearable
              :disabled="true"
              :value="commodityTypeCode"
            >
              <el-option
                v-for="(i, index) in commodityClassificationList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingUnit'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in pricingUnitOptions"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'pricingStandard'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => pricingStandardChange(row, val)"
            >
              <el-option
                v-for="(i, index) in pricingStandardList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'expenseCode'"
              filterable
              clearable
              :disabled="canEdit"
              v-model="row[item.field]"
              @change="(val) => changeExpenseCode(row, val)"
            >
              <el-option
                v-for="(i, index) in expenseList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'packingId'"
              :clearable="true"
              :filterable="true"
              :disabled="canEdit"
              multiple
              v-model="row[item.field]"
              @change="(val) => changecommoditySpecifications(val, row, '05')"
            >
              <el-option
                v-for="(i, index) in packList"
                :key="index"
                :label="i.name"
                :value="i.id"
              ></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'packageCategoryName'"
              :filterable="true"
              :clearable="true"
              :disabled="canEdit"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in packageCategoryNameList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-input
              v-else-if="item.editRender.name == 'lowerTimeLimit'"
              :disabled="disabledTimeLimit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <el-input
              v-else-if="item.editRender.name == 'upperTimeLimit'"
              :disabled="disabledTimeLimit"
              v-model="row[item.field]"
              placeholder="请输入"
            >
            </el-input>
            <input-number-ad
              v-else-if="item.editRender.name == 'lowerWeightLimit'"
              v-model="row.lowerWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="disabledWeightLimit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'upperWeightLimit'"
              v-model="row.upperWeightLimit"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="disabledWeightLimit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'unitPrice'"
              v-model="row.unitPrice"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="4"
              :clearable="true"
              class="inputWidth"
              :disabled="canEdit"
              maxlength="10"
            ></input-number-ad>
            <input-number-ad
              v-else-if="item.editRender.name == 'minimumAmount'"
              v-model="row.minimumAmount"
              :controls="false"
              :min="0"
              :max="999999999"
              :precision="0"
              :clearable="true"
              class="inputWidth"
              :disabled="canEdit"
              maxlength="10"
            ></input-number-ad>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import goodsMixins from '../../../mixins/goodsMixins';

  export default {
    name: 'specialCostChart',
    mixins: [goodsMixins],
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      showTableBtn: {
        type: Boolean,
        default: true,
      },
      isDisabled: {
        type: Boolean,
        default: true,
      },
      goodsType: {
        type: Array,
        default: () => [],
      },
      commodityTypeCode: {
        type: String,
        default: () => '',
      },
      goodsCategoryRow: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columns: [],
        pricingStandardList: [],
        pricingUnitList: [],
        pricingUnitOptions: [],
        goodsTypeList: [],
        goodsCategoryList: [],
        goodsCategoryAll: [],
        expenseList: [],
        packageCategoryNameList: [], //包装类别
        ids: [],
        canEdit: false,
        disabledTimeLimit: true, //控制时间上下限能否编辑
        disabledWeightLimit: true, //控制重量上下限能否编辑
        tableRule: {
          // commodityTypeCode: [
          //   { required: true, message: '商品类型必填', trigger: ['change', 'blur'] },
          // ],
          expenseCode: [{ required: true, message: '费用名称必填', trigger: ['change', 'blur'] }],
          pricingStandard: [
            { required: true, message: '计价标准必填', trigger: ['change', 'blur'] },
          ],
          pricingUnit: [{ required: true, message: '计价单位必填', trigger: ['change', 'blur'] }],
          unitPrice: [{ required: true, message: '单价必填', trigger: ['change', 'blur'] }],
        },
        commodityClassificationList: [],
        commodityClassificationName: '',
      };
    },
    mounted() {
      this.getExpenseListByCompanyName();
      this.columns = chartColumns;
      console.log(this.expenseList, '特殊费用下拉选项');
      this.pricingStandardList = this.dictListMap.warehousePricingStandard;
      this.pricingUnitList = this.dictListMap.warehousePricingUnit;
      this.packageCategoryNameList = this.dictListMap.warehouseContractPackageType;
    },
    methods: {
      // 新增行
      async newRowHandler() {
        this.$refs.dialogRef.openModal();
      },
      // 选中行
      handleSelectionChange({ selection }) {
        this.selectionList = selection;
      },
      // 删除处理事件
      deleteRowHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.selectionList = [];
      },
      // 判断公司获取费用类型
      getExpenseListByCompanyName() {
        if (this.userInfo.companyName == '广西供应链服务集团贵港储运有限公司') {
          this.expenseList = this.dictListMap.warehouseExpenseName;
        } else if (this.userInfo.companyName == '广西供应链服务集团桂林储运有限公司') {
          this.expenseList = this.dictListMap.warehouseContractGuilinExpenseList;
        } else {
          this.expenseList = this.dictListMap.warehouseExpenseName;
        }
      },
      // 货物类型切换时更新级联的下拉数据
      async goodsTypeChange(row, val) {
        let commodityTypeNameList = this.goodsTypeList.filter((item) => val.includes(item.value));
        row.commodityTypeName = this.goodsTypeList.find((item) => item.value == val)?.label;
        // row.commodityClassification = this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeName;
        // row.commodityClassificationCode = this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeCode;
        row.commodityCategoryName = '';
        row.commodityCategoryCode = null;
        row.commodityTypeId = commodityTypeNameList.map((item) => {
          return item.id;
        });
        row.commoditySpecifications = null;
        row.detailProductItems = null;
        // row.commodityTypeName = this.goodsTypeList.find((item) => item.value == val)?.label;
        // row.commodityClassification = this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeName;
        // row.commodityClassificationCode = this.goodsTypeList.find(
        //   (item) => item.value == val
        // )?.typeCode;
        // row.commodityCategoryName = '';
        // row.commodityCategoryCode = null;
        // row.commoditySpecifications = null;
        this.updateCategory(row);
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        const goodsType = row.commodityTypeCode;
        if (goodsType?.length) {
          const item = this.goodsCategoryAll.filter((item) =>
            goodsType.includes(item.productParentCode)
          );
          if (item.length !== 0) {
            this.goodsCategoryList = item.map((item) => {
              if (item.productDetailCode) {
                return {
                  ...item,
                  value: item.productDetailCode,
                  label: item.productChName,
                };
              }
            });
          }
        }
      },
      // 表格行激活时处理函数
      editActivedEvent({ row }) {
        console.log('激活行');
        // 获取规格、包装列表
        this.focusHandler(row, '04'); //规格
        this.focusHandler(row, '05'); //包装
        row.commodityClassificationCode = this.commodityTypeCode;
        row.commodityClassificationName = this.commodityClassificationName;
        this.updateCategory(row);
        this.pricingUnitOptions = this.filterUtil(row.pricingStandard);
      },
      // 货物品类选择时更新货物规格
      commodityCategoryChange(val, row) {
        const itemList = this.goodsCategoryAll.filter((item) =>
          val.includes(item.productDetailCode)
        );
        console.log(val, row, itemList, 'val-row');
        let commodityCategoryNameList = [];
        let commoditySpecificationsList = [];
        let packList = [];
        let detailProductItemsList = [];
        if (itemList?.length) {
          itemList.map((item) => {
            if (item.productChName) commodityCategoryNameList.push(item.productChName);
            if (item.detailProductModelId) commoditySpecificationsList.push(item);
            if (item.detailProductItems) detailProductItemsList.push(item.detailProductItems);
            if (item.detailProductPacksId) packList.push(item);
          });
        }
        row['commodityCategoryName'] = commodityCategoryNameList.length
          ? commodityCategoryNameList.join(',')
          : '';
        row['commoditySpecificationsList'] = commoditySpecificationsList;
        row['packList'] = packList;
        console.log(detailProductItemsList, '货物分类');
        row['detailProductItems'] = detailProductItemsList.length
          ? detailProductItemsList.join(',')
          : '';
        // const item = this.goodsCategoryAll.find((item) => item.productDetailCode == val);
        // row['commodityCategoryName'] = item.productChName;
        // row['commoditySpecifications'] = item.detailProductModel;
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.specialCostChartRef;
          const tableData = $table.getTableData().fullData;
          console.log(tableData, '表格数据');
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  parkCompany: this.userInfo.companyName,
                  parkCompanyCode: this.userInfo.companyCode,
                  businessDepartmentCode: this.userInfo.departmentCode,
                  commodityCategoryCode: item.commodityCategoryCode?.length
                    ? item.commodityCategoryCode.join(',')
                    : '',
                  commodityTypeCode: item.commodityTypeCode?.length
                    ? item.commodityTypeCode.join(',')
                    : '',
                  commodityClassification: this.commodityClassificationList.find(
                    (item) => item.id == item.commodityClassificationCode
                  )?.label,
                  commoditySpecificationsId: item.commoditySpecificationsId?.length
                    ? item.commoditySpecificationsId.join(',')
                    : '',
                  packingId: item.packingId?.length ? item.packingId.join(',') : '',
                };
              });
              console.log(formTableData, 'formTableData');
              resolve({ tableData: formTableData });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.specialCostChartRef;
        return $table.getTableData().fullData;
      },
      // 改变费用名称事件
      changeExpenseCode(row, val) {
        const item = this.expenseList.find((item) => item.value == val);
        row.expenseName = item.label;
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null || value == '') {
          return;
        }
        let item;
        if (type == 'commodityType') {
          console.log('commodityType', this.goodsTypeList);
          if (!this.goodsTypeList.length || value == null || value == '') {
            return value;
          }
          item = this.goodsTypeList
            .filter((item) => value.includes(item.value))
            .map((item) => {
              return item.label;
            });
          return item?.length ? item.join(',') : '';
        } else if (type == 'commodityCategory') {
          return value;
        } else if (type == 'pricingStandard') {
          item = this.pricingStandardList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'pricingUnit') {
          item = this.pricingUnitList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'expenseCode') {
          item = this.expenseList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'packageCategoryName') {
          if (!this.packageCategoryNameList.length) {
            return value;
          }
          item = this.packageCategoryNameList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'commodityClassificationCode') {
          if (!this.commodityClassificationList.length) {
            return value;
          }
          item = this.commodityClassificationList.find((item) => item.value == value);
          return item?.label;
        }
      },
      // 填充表格数据
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 筛选计价单位
      filterUtil(fieldValue) {
        if (fieldValue == 'time') {
          // 时间
          return this.pricingUnitList.filter((item) => ['yuan_time'].includes(item.value));
        } else if (fieldValue == '02') {
          // 一口价
          return this.pricingUnitList.filter((item) => ['14'].includes(item.value));
        } else if (fieldValue == '03') {
          // 重量
          return this.pricingUnitList.filter((item) => ['07', '08'].includes(item.value));
        } else if (fieldValue == '04') {
          // 数量
          return this.pricingUnitList.filter((item) => ['09', '10', '11'].includes(item.value));
        } else if (fieldValue == '05') {
          // 车次
          return this.pricingUnitList.filter((item) => ['12', '13'].includes(item.value));
        } else if (fieldValue == 'day') {
          // 按天数
          return this.pricingUnitList.filter((item) =>
            ['yuan_ton', 'yuan_ge', 'yuan_che'].includes(item.value)
          );
        }
      },
      // 选择计价标准事件
      pricingStandardChange(row, val) {
        row.pricingUnit = null;
        row.lowerTimeLimit = null;
        row.upperTimeLimit = null;
        row.lowerWeightLimit = null;
        row.upperWeightLimit = null;
        if (val == 'time') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else if (val == '03') {
          this.disabledTimeLimit = true;
          this.disabledWeightLimit = false;
        } else if (val == 'day') {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = false;
        } else {
          this.disabledWeightLimit = true;
          this.disabledTimeLimit = true;
        }
        this.pricingUnitOptions = this.filterUtil(val);
      },
      // 表单商品类别变化时， 更改表格商品信息
      goodsTypeChage() {
        if (!this.canEdit && this.$refs.specialCostChartRef.getTableData().fullData.length) {
          const tableData = this.$refs.specialCostChartRef.getTableData().fullData;
          tableData.forEach((item) => {
            item.commodityTypeCode = null;
            item.commodityCategoryCode = null;
            item.commoditySpecifications = null;
            item.detailProductItems = null;
          });
          this.tableData = tableData;
        }
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.tableData = val.map((item) => {
              return {
                ...item,
                commodityCategoryCode: item.commodityCategoryCode
                  ? item.commodityCategoryCode.split(',')
                  : [],
                commodityTypeCode: item.commodityTypeCode ? item.commodityTypeCode.split(',') : [],
                commoditySpecificationsId: item.commoditySpecificationsId?.length
                  ? item.commoditySpecificationsId.split(',')
                  : [],
                packingId: item.packingId?.length ? item.packingId.split(',') : [],
              };
            });
          }
        },
        immediate: true,
      },
      isDisabled: {
        handler(val) {
          if (this.$route.query?.pageMode !== 0) {
            this.canEdit = val;
          }
        },
        immediate: true,
      },
      goodsType: {
        handler(val) {
          this.goodsTypeList = val;
          // if (!this.canEdit) {
          //   const tableData = this.$refs.specialCostChartRef.getTableData().fullData;
          //   tableData.forEach((item) => {
          //     item.commodityTypeCode = null;
          //     item.commodityCategoryCode = null;
          //     item.commoditySpecifications = null;
          //   });
          //   this.tableData = tableData;
          // }
        },
      },
      commodityTypeCode: {
        handler(val) {
          console.log('监听到商品类型变化', val, this.commodityClassificationList);
          this.commodityClassificationName = this.commodityClassificationList.find(
            (item) => item.id == val
          )?.label;
          this.productCategoryId = this.commodityClassificationList.find(
            (item) => item.value == val
          )?.id;
          console.log(this.productCategoryId);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
      ::v-deep .multiple-select {
        .vxe-cell {
          max-height: fit-content;
        }
      }
    }
  }
</style>
